import { Dialog } from "@dash/dialog";
import { Button, TextField } from "@dash/form";
import { SelectDialog } from "@dash/select";
import React, { useState } from "react";
import { MdAdd } from "react-icons/md";

import { useClientManager } from "@megaron/react-clients";
import { TicketStatus, type TicketCategory } from "@megaron/support-contracts";
import { Uuid } from "@megaron/uuid";

import { getSupportTagOptions } from "./supportTagSuggestions";

type Props = {
  ticketId: Uuid;
  subject: string;
  status: TicketStatus;
  priority: "low" | "medium" | "high" | "urgent" | null;
  category: TicketCategory | null;
  invoiceNumber: string | null;
  ticketTags: string[];
  onSuccess: () => void;
  onClose: () => void;
};

export const SupportEditTagsDialog: React.FC<Props> = (props) => {
  const saveTags = useClientManager("support").updateTicket().useMutation();

  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
  const [newTag, setNewTag] = useState("");

  const saveTicketTags = (tags: string[]) => {
    const normalizedTags = tags
      .map((tag) => tag.trim().toLowerCase())
      .filter((tag, index, all) => tag.length > 0 && all.indexOf(tag) === index);
    saveTags.mutate(
      {
        id: props.ticketId,
        subject: props.subject,
        status: props.status,
        priority: props.priority,
        category: props.category,
        tags: normalizedTags,
        invoiceNumber: props.invoiceNumber,
      },
      {
        onSuccess: () => {
          props.onSuccess();
        },
      },
    );
  };

  const handleAddTag = () => {
    const trimmed = newTag.trim().toLowerCase();
    if (!trimmed || props.ticketTags.includes(trimmed)) return;
    const updated = [...props.ticketTags, trimmed];
    saveTicketTags(updated);
    setNewTag("");
    setIsAddDialogOpen(false);
  };

  return (
    <>
      <SelectDialog
        variant="multi-select"
        noTrigger
        isOpen
        onClose={props.onClose}
        initiallySelectedValues={props.ticketTags}
        onSelectedChange={(tags) => {
          const values = tags.map((t) => t.value);
          saveTicketTags(values);
        }}
        search={async (searchText) => getSupportTagOptions(searchText, props.ticketTags)}
        shouldNotCloseOnSelect
        optionalHeaderRightIcon={<MdAdd style={{ cursor: "pointer" }} onClick={() => setIsAddDialogOpen(true)} />}
      />

      {isAddDialogOpen && (
        <Dialog header="Dodaj nowy tag" onClose={() => setIsAddDialogOpen(false)}>
          <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
            <TextField value={newTag} onChange={setNewTag} autoFocus />
            <Button onClick={handleAddTag} isDisabled={!newTag.trim()}>
              Zapisz
            </Button>
          </div>
        </Dialog>
      )}
    </>
  );
};
